/* eslint-disable no-useless-escape */
/**
 * 手机号码
 * @description
 * @type {RegExp}
 */
export const phoneRegexp = /^1[34578]\d{9}$|^1((99)|(66)|(98)|(91)|(65))\d{8}$/
/**
 * 邮箱地址
 * @description 大小写字母数子下划线（_）和连接符（-）--- @ ---
 *              大小写字母数子下划线（_）和连接符（-）--- . ---
 *              大小写字母数子下划线（_）和连接符（-）
 * @type {RegExp}
 */
export const emailRegexp = /^([a-zA-Z0-9._-])+@([a-zA-Z0-9_-])+(\.[a-zA-Z0-9_-])+/

/**
 * 固定电话
 */
export const telephoneRegexp = /^0(?:[3-9]\d{2}|0852|0853|0886|2\d|10)(-)?\d{7,8}$/

/**
 * 只能输入合法字符，包括空格
 */
export const allowableRegexp = '^[ a-zA-Z0-9_\u4e00-\u9fa5]+$'

/**
 * 大于0，最多保留两位小数
 */
export const fix2Regexp = '^([1-9]d*$)|([1-9]d*.(d{1,2})$)|(0.((0[1-9])|([1-9]d?))$)'

/**
 * 匹配所有空格
 */
export const blankRegexp = '\\s+'

/**
 * 纯数字
 */
 export const numberRegexp = /^\d+$/

 /**
 * 宽泛网址
 */
  // export const urlRegexp = /([--:\w?@%&+~#=]*\.[a-z]{2,4}\/{0,2})((?:[?&](?:\w+)=(?:\w+))+|[--:\w?@%&+~#=]+)?/
  export const wideUrlRegexp = /^(\w+\.)+(\w+)$/